
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-gpk/pegawai/pelaksanaan/persiapan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-gpk/pegawai/pelaksanaan/persiapan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-gpk/pegawai/pelaksanaan/persiapan"])
      });
    }
  